import React, { useState, useContext, useEffect } from "react";
import { Flex } from "@cisco/spaces-dash-lib-styleguide";
import { AppCenter } from "@cisco/spaces-dash-app-appcenter";
import { LocationTree } from "@cisco/spaces-dash-app-lh2";
import { LocationLib } from "@cisco/spaces-dash-lib-lh2";
import { I18nContext } from "../../contexts/i18nContext";

function AppActivationSandbox() {
  const i18n = useContext(I18nContext);
  const [showHome, setShowHome] = useState(false);
  const isPartnerDashboard = true;

  useEffect(() => {
    i18n.loadNamespaces("spaces-dash-app-home", (err, t) => {
      setShowHome(true);
      console.log(`${err} ${t}`);
    });
  }, []);

  return (
    showHome && (
      <Flex style={{ margin: "24px 30px 0px 24px", maxWidth: "100%" }}>
        <LocationLib isPartnerDashboard={isPartnerDashboard} />
        <div style={{ visibility: "hidden", height: 0, width: 0, opacity: 0 }}>
          <LocationTree params={{ type: "single", appName: "pd-home" }} />
        </div>
        <Flex style={{ width: "100%" }} direction="vertical" gap={16}>
          <AppCenter {...{ appData: { i18n, isPartnerDashboard: true } }} />
        </Flex>
      </Flex>
    )
  );
}

export default AppActivationSandbox;
